import React, { Component } from 'react'
import moment from 'moment'

// Components
import ProfileTabSection from '../../../components/Profile/ProfileTabSection'
import ProfileStatsBlock from '../../../components/Profile/ProfileStatsBlock'
import ProfileDropdown from '../../../components/Profile/ProfileDropdown'
import ProfileSeasonOverallStats from '../../../components/Profile/ProfileSeasonOverallStats'

// Packages
import shortid from 'shortid'

const Game = ({ player_stats, gameNumber, name, date, positions }) => (
  <div className="profile-stats-game">
    <h2>
      {name} – {date} | {
        positions.map((position, index) => {
          return positions.length > index + 1
          ? position.name + ', '
          : position.name
        })
      }
    </h2>
    <div className="profile-stats-row">
      {
        player_stats.map((statCategory) => {
          return (
            <ProfileStatsBlock {...statCategory} key={shortid.generate()} />
          )
        })
      }
    </div>
  </div>
)

class PlayerProfileStats extends Component {

  state = {
    selectedSeason: null
  }

  componentDidMount() {
    this.setState({ selectedSeason: this.orderedSeasons()[0] })
  }

  setSelectedSeason = (selectedSeason) => this.setState({ selectedSeason })

  orderedSeasons = () => {
    const { seasons } = this.props

    let sortedSeasons = seasons.sort((a, b) => {
      return a.ends_on > b.ends_on ? -1 : 1
    }).filter((season) => {
      return season.games.length > 0
    })

    return sortedSeasons
  }

  selectedSeasonOrderedGames = () => {
    const { selectedSeason } = this.state

    if (!selectedSeason) return []

    return selectedSeason.games.sort((a, b) => a.played_on > b.played_on ? -1 : 1)
  }


  render() {
    const { sport } = this.props
    const { selectedSeason } = this.state
    const games = this.selectedSeasonOrderedGames()

    return selectedSeason
    ? (
      <ProfileTabSection optionalClasses="profile-stats">
        <div className="profile-stats-overview">
          <div className="profile-stats-overview-header">
            <h2 className="profile-tab-section-heading">
              Overall Stats
            </h2>
            <div className="season-info">
              <h2 className="profile-tab-section-heading season-info-heading">
                {selectedSeason.school_played_for}
              </h2>
              <ProfileDropdown
                options={this.orderedSeasons()}
                selectedOption={selectedSeason}
                handleSelectionUpdate={this.setSelectedSeason}
              />
            </div>
          </div>
          <ProfileSeasonOverallStats games={selectedSeason.games} sport={sport} />
        </div>
        {
          games.map((game, index) => (
            <Game
              {...game}
              gameNumber={games.length - index}
              key={index}
              name={game.description}
              date={moment(game.played_on).format('MMM DD, YYYY')}
              positions={game.played_positions}
            />
          ))
        }
      </ProfileTabSection>
    )
    : (
      <ProfileTabSection>
        <div className="empty-state-message">
          This user hasn't added a season yet...
        </div>
      </ProfileTabSection>
    )
  }
}

export default PlayerProfileStats



// WEBPACK FOOTER //
// ./src/screens/Profile/ProfileSections/PlayerProfileStats.js